<template>
  <span>
    <template v-if="hasDiscount">
      <span class="inline-flex items-center">
        <span class="opacity-70 line-through pr-1">{{ priceLabel }}</span>
        <o-chip icon="tag" variant="primary" size="xs" flat>
          <span v-if="priceFrom" class="pr-1">{{ $t('general.from') }}</span>{{ discountedPrice }}
        </o-chip>
        <span v-if="priceHasAdditionalTaxes">{{ $t('general.plusTax') }}</span>
      </span>
    </template>
    <template v-else>
      <strong class="hidden sm:inline pr-1">{{ $t('general.price') }}:</strong>
      <span v-if="priceFrom"> {{ $t('general.from') }}</span>
      {{ priceLabel }}
      <span v-if="priceHasAdditionalTaxes">{{ $t('general.plusTax') }}</span>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    priceLabel: {
      type: String,
      required: true,
    },
    priceFrom: {
      type: Boolean,
      default: false,
    },
    priceHasAdditionalTaxes: {
      type: Boolean,
      default: false,
    },
    hasDiscount: {
      type: Boolean,
      default: false,
    },
    discountedPrice: {
      type: String,
      default: '',
    },
  },
}
</script>
